import { CurrencyField } from '@/components/ui/CurrencyField';
import { PercentageField } from '@/components/ui/PercentageField';

interface MinMaxFieldProps {
  label: string;
  minValue: string;
  maxValue: string;
  onMinChange: (val: string) => void;
  onMaxChange: (val: string) => void;
  isCurrency: boolean;
}

export default function MinMaxField({
  label,
  minValue,
  maxValue,
  onMinChange,
  onMaxChange,
  isCurrency,
}: MinMaxFieldProps) {
  const FilterField = isCurrency ? CurrencyField : PercentageField;

  const hasRangeError = minValue !== '' && maxValue !== '' && parseFloat(minValue) > parseFloat(maxValue);

  return (
    <div className="flex flex-col w-full">
      <h4 className="text-sm font-medium text-black font-avenir mb-3">{label}</h4>
      <div className="flex flex-row items-center gap-2 w-full">
        <FilterField
          value={minValue}
          onChange={onMinChange}
          placeholder="Min"
          className="flex-1 min-w-0"
          error={hasRangeError}
        />
        <span className="text-gray-400 font-medium text-sm select-none">–</span>
        <FilterField
          value={maxValue}
          onChange={onMaxChange}
          placeholder="Max"
          className="flex-1 min-w-0"
          error={hasRangeError}
        />
      </div>
      {hasRangeError && <p className="text-[#CC4747] text-xs mt-1">Min value cannot exceed max value</p>}
    </div>
  );
}
